<template>
  <TheMenuLayout>
    <BaseSectionHeader class="mb-2">
      {{$t('Marks')}}
    </BaseSectionHeader>
    <div v-if="evaluations.average_mark">
      <BaseButton
        @click="downloadReportCard"
        small
        block
        color="primary"
        outlined
        icon="mdi-file-pdf"
        class="mb-4"
      >
        {{$t('Download my summary')}}
      </BaseButton>

      <v-divider class="mb-4" />

      <BaseSectionHeader>
        {{$t('Last semester')}}
      </BaseSectionHeader>
      <v-row>
        <v-col>
          <BaseNumberCard color="grey lighten-3" :title="$t('General ranking')">
            {{ evaluations.rank }}
          </BaseNumberCard>
        </v-col>
        <v-col>
          <BaseNumberCard color="grey lighten-3" :title="$t('Average mark')">
            <span v-if="evaluations.average_mark">
              {{ evaluations.average_mark.toLocaleString(undefined, { maximumFractionDigits: 2 }) }}/20
            </span>
            <span v-else>NA</span>
          </BaseNumberCard>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <BaseButton
            block
            color="primary"
            icon="mdi-chart-donut"
            to="/notes/progression"
          >
            {{$t('Visualize progression')}}
          </BaseButton>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <BaseButton
            block
            color="primary"
            icon="mdi-chart-bar"
            class="mb-4"
            to="/notes/classement"
          >
            {{ $t('Visualize rank') }}
          </BaseButton>
        </v-col>
      </v-row>

      <v-divider class="mb-4" />

      <BaseSectionHeader>
        Détail des notes
      </BaseSectionHeader>
      <BaseButton
        v-for="semester in availableSemesters"
        :key="semester"
        @click="goToSemesterView(semester)"
        block
        outlined
        color="primary"
        icon="mdi-school"
        class="mb-4"
      >
        {{ semester }}
      </BaseButton>
    </div>
    <BaseEmptyState v-else>
      Vous n'avez pas encore de note enregistrée
    </BaseEmptyState>
  </TheMenuLayout>
</template>

<script>
import {
  mapState, mapActions, mapGetters,
} from 'vuex';

import BaseSectionHeader from '@/components/BaseSectionHeader.vue';
import TheMenuLayout from '@/components/TheMenuLayout.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseNumberCard from '@/components/BaseNumberCard.vue';
import BaseEmptyState from '@/components/BaseEmptyState.vue';

export default {
  name: 'Evaluations',
  components: {
    BaseSectionHeader,
    TheMenuLayout,
    BaseButton,
    BaseEmptyState,
    BaseNumberCard,
  },
  created() {
    this.fetchEvaluations();
  },
  computed: {
    ...mapState(['evaluations']),
    ...mapGetters(['availableSemesters']),
  },
  methods: {
    ...mapActions(['fetchEvaluations']),
    goToSemesterView(semester) {
      this.$router.push({ path: '/notes/semestre', query: { semester } });
    },
    downloadReportCard() {
      this.axios({
        url: '/report_card',
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Relevé de notes.pdf');
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>
